import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/AppSidebar';
import { HelpMenuProvider } from '@/contexts/HelpMenuContext';

/**
 * Inner layout component that renders the sidebar and main content
 */
function DashboardLayoutInner() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="flex flex-col min-w-0 h-svh overflow-hidden">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
        </header>
        <main className="flex flex-1 flex-col p-8 overflow-auto">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}

/**
 * Dashboard layout with sidebar navigation and help menu blade
 * This layout wraps all /dashboard/* routes
 */
export default function DashboardLayout() {
  return (
    <HelpMenuProvider>
      <DashboardLayoutInner />
    </HelpMenuProvider>
  );
}
